import { render, staticRenderFns } from "./LogoLayout.vue?vue&type=template&id=16a911df&scoped=true"
import script from "./LogoLayout.vue?vue&type=script&lang=js"
export * from "./LogoLayout.vue?vue&type=script&lang=js"
import style0 from "./LogoLayout.vue?vue&type=style&index=0&id=16a911df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a911df",
  null
  
)

export default component.exports